import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHandPointUp, faMousePointer, faPaintBrush, faEraser, faSave, faUndoAlt } from '@fortawesome/free-solid-svg-icons';
import { Button, useMediaQuery } from '@mui/material';
import json2mq from 'json2mq';
import { shortQueries } from '../queries';

export const MeasurItColorEraseTour = (props) => {

    const short = useMediaQuery(json2mq(shortQueries));

    const textStyle = {
        fontFamily: "'Open Sans', sans-serif",
        fontSize: short ? 14 : 16
    }

    return (
        <div style={textStyle}>
            
            <img src="/Measureit-logo.png" alt="measureit-welcome" style={{height: 40}} />
            <p>
            Use your finger or cursor to color in the areas to be serviced. Use the marker, size, eraser and undo tools for fine tuning your selection.
            <br/><br/>
            Save the estimate by clicking the quote button.
            </p>
            {false ? null : (
                <img src="/measur.it-draw-undo.gif" alt="animate pan zoom" style={{width: 200}} />
            )}
            <Button sx={{ float: 'right' }} variant='contained' onClick={() => props.goTo(1)}>Next</Button>
        </div>
    )
}

MeasurItColorEraseTour.propTypes = {
    closeTour: PropTypes.func.isRequired
}